import { useCallback } from "react";
import { ChakraProps } from "@chakra-ui/react";
import { AsyncSearchProvider } from "./AsyncSearchProvider";
import AsyncSelect from "./AsyncSelect";
import useLootTables from "../../hooks/lootTables/useLootTables";

interface SelectLootTableProps extends ChakraProps {
  value: string;
  setValue: (value: string) => void;
}

function SelectLootTable({ color, value, setValue, ...chakraProps }: SelectLootTableProps) {
  const { isLoading, error, lootTables = [] } = useLootTables();

  const handleSearch = useCallback(
    async (searchQuery?: string): Promise<[string, string][]> => {
      return lootTables
        .filter(({ lootTableId }) => lootTableId.toLowerCase().includes(searchQuery?.toLowerCase().trim() ?? ""))
        .map(({ lootTableId }) => [lootTableId, `${lootTableId}`]);
    },
    [lootTables]
  );

  return (
    <AsyncSearchProvider onSearchAsync={handleSearch}>
      <AsyncSelect
        selectedValue={value}
        setSelectedValue={setValue}
        color={color}
        title={"Loot Table"}
        isLoading={isLoading}
        error={error}
        {...chakraProps}
      />
    </AsyncSearchProvider>
  );
}

export default SelectLootTable;
